/* eslint-disable */
import { useContext, useEffect, useState } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import useApp from '../../../hooks/useApp';
import { Autocomplete } from '@material-ui/lab';
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from '@material-ui/core';

import { fetcher } from '../../../service/SWRFetcher';
import useSWR from 'swr';
import IndicationManagerReportTableList from '../../IndicationManagerReportTableList';
import SimpleModal from '../../SimpleModal';
import SearchClientModal from '../../SearchClientModal';
import filterStyles from '../../filterStyles/index';
import CloseIcon from '@material-ui/icons/Close';
import { matchOption, matchOptions } from '../../../utils/filterOptions';

const DatePeriodFilter = ({ userId, filters, setFilters }) => {
  const { insurances, channels } = useApp();
  const classes = filterStyles();

  const [dates, setDates] = useState({
    date_ini: filters?.date_ini || DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: filters?.date_end || DateTime.now().toISODate(),
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: inviters } = useSWR(`/users`, fetcher, { revalidateOnFocus: false });
  const { data: partners } = useSWR(`/partners/by/auth`, fetcher, { revalidateOnFocus: false });

  function handleSubmit(event) {
    event.preventDefault();
    let filt = {
      date_ini: event.target.elements.date_ini?.value,
      date_end: event.target.elements.date_end?.value,
      partner_id: partner.map((p) => p.id) || [],
      insurance_id: insurance.map((i) => i.id) || [],
      channel_id: channel.map((c) => c.id) || [],
      inviter_id: inviter?.id || '',
      client_id: client?.id || '',
      client_name: client?.name || '',
    };
    setFilters({ ...filters, ...filt });
  }

  const [partner, setPartner] = useState([]);

  const [insurance, setInsurance] = useState([]);

  const [channel, setChannel] = useState([]);

  const [inviter, setInviter] = useState(null);

  const [client, setClient] = useState([]);

  // As opções chegam depois do primeiro render (useApp / useSWR), então cada
  // Autocomplete é reidratado com os ids da URL assim que a sua lista existe.
  useEffect(() => {
    setPartner(matchOptions(partners, filters?.partner_id));
  }, [partners]);

  useEffect(() => {
    setInsurance(matchOptions(insurances, filters?.insurance_id));
  }, [insurances]);

  useEffect(() => {
    setChannel(matchOptions(channels, filters?.channel_id));
  }, [channels]);

  useEffect(() => {
    setInviter(matchOption(inviters, filters?.inviter_id));
  }, [inviters]);

  // O cliente é escolhido por modal, então o nome viaja junto na URL: não há
  // lista carregada de onde recuperá-lo a partir do id.
  useEffect(() => {
    if (filters?.client_id) setClient({ id: filters.client_id, name: filters.client_name || '' });
  }, []);

  const handleChangeDates = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setDates({
      ...dates,
      [name]: value,
    });
  };

  return (
    <Box className={classes.boxFilter}>
      <form className="form" onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container alignItems="flex-end" spacing={2}>
          <Grid
            item
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              color: 'GrayText',
            }}>
            <Typography>Data de criação da proposta inicial: </Typography>
            <TextField
              className={classes.inputDate}
              type="date"
              name="date_ini"
              value={dates.date_ini}
              onChange={handleChangeDates}
            />
          </Grid>

          <Grid
            item
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              color: 'GrayText',
            }}>
            <Typography>Data de criação da proposta final: </Typography>

            <TextField
              className={classes.inputDate}
              type="date"
              name="date_end"
              placeholder="Data Final"
              value={dates.date_end}
              onChange={handleChangeDates}
            />
          </Grid>

          <Grid item xs>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} md={2}>
                <Autocomplete
                  multiple
                  fullWidth
                  name="partners"
                  options={partners || []}
                  value={partner}
                  getOptionLabel={(option) => option?.name}
                  getOptionSelected={(option, value) => option?.id === value?.id}
                  className={classes.inputSelect}
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Empresas" />}
                  onChange={(e, value) => setPartner(value)}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Autocomplete
                  className={classes.inputSelect}
                  multiple
                  options={insurances || []}
                  value={insurance}
                  getOptionLabel={(option) => option?.name}
                  getOptionSelected={(option, value) => option?.id === value?.id}
                  onChange={(e, value) => setInsurance(value)}
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Tipos de Estoque" />}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Autocomplete
                  className={classes.inputSelect}
                  multiple
                  options={channels || []}
                  value={channel}
                  getOptionLabel={(option) => option?.name}
                  getOptionSelected={(option, value) => option?.id === value?.id}
                  onChange={(e, value) => setChannel(value)}
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Canais" />}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Autocomplete
                  className={classes.inputSelect}
                  options={inviters || []}
                  value={inviter}
                  getOptionLabel={(option) => option?.name}
                  getOptionSelected={(option, value) => option?.id === value?.id}
                  onChange={(e, value) => setInviter(value)}
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Indicador" />}
                />
              </Grid>

              <Grid item>
                <FormControl>
                  <TextField
                    className={classes.inputDate}
                    type="text"
                    maxlength="0"
                    placeholder="Nome do Cliente"
                    onClick={() => setIsModalOpen(true)}
                    name="client_name"
                    value={client.name ? client.name : ''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <CloseIcon
                            viewBox="0 0 24 24"
                            focusable="false"
                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                            ariaHidden="true"
                            cursor="pointer"
                            onClick={() => setClient({})}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item>
                <SearchClientModal
                  open={isModalOpen}
                  title="Nome do Cliente"
                  setOpen={() => {
                    setIsModalOpen((oldState) => !oldState);
                  }}
                  fieldName="Pesquise pelo nome do cliente"
                  next={(client) => {
                    setClient(client);
                    setIsModalOpen(false);
                  }}
                />
              </Grid>

              <Grid item>
                <Button fullWidth className={classes.button} type="submit">
                  Filtrar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
    // <Nav>
    //   <NavbarForm>
    //     <form className="form" onSubmit={handleSubmit}>
    //       <div className="inputs">
    //         <div className="date_ini">
    //           <input
    //             type="date"
    //             name="date_ini"
    //             className="input-form"
    //             placeholder="Data Inicial"
    //             value={dates.date_ini}
    //             onChange={(e) => setDates(e)}
    //           />
    //         </div>
    //         <div className="date_end">
    //           <input
    //             type="date"
    //             name="date_end"
    //             className="input-form"
    //             placeholder="Data Final"
    //             value={dates.date_end}
    //             onChange={(e) => setDates(e)}
    //           />
    //         </div>
    //       </div>

    //       <Autocomplete
    //         multiple
    //         options={partners ? partners : []}
    //         getOptionLabel={(option) => option?.name}
    //         onChange={(e, value) => setPartner(value)}
    //         renderInput={(params) => (
    //           <TextField {...params} className="autocomplete" variant="standard" placeholder="Empresas" />
    //         )}
    //       />

    //       {/* <div className="insurance_id">
    //         <select type="select" name="insurance_id" className="select-form" placeholder="Seguro" value={insurance.partner_id} onChange={(e) =>setInsurance(e)}>
    //         <option value="">Tipo Estoque</option>
    //           {insurances.map((item) => (
    //            <option key={item.id} value={item.id}>{item.name}</option>
    //           ))}
    //         </select>
    //       </div> */}

    //       <Autocomplete
    //         multiple
    //         options={insurances ? insurances : []}
    //         getOptionLabel={(option) => option?.name}
    //         onChange={(e, value) => setInsurance(value)}
    //         renderInput={(params) => (
    //           <TextField {...params} className="autocomplete" variant="standard" placeholder="Tipos de Estoque" />
    //         )}
    //       />

    //       <Autocomplete
    //         options={inviters ? inviters : []}
    //         getOptionLabel={(option) => option?.name}
    //         onChange={(e, value) => setInviter(value)}
    //         renderInput={(params) => (
    //           <TextField {...params} className="autocomplete" variant="standard" placeholder="Indicador" />
    //         )}
    //       />

    //   <div className="inputs">
    //   <div className="client_name">
    //     <div className="customInput">
    //       <input
    //         maxlength="0"
    //         value={client.name ? client.name : ''}
    //         name="client_name"
    //         className="input-form"
    //         placeholder="Nome do Cliente"
    //         onClick={() => setIsModalOpen(true)}
    //       />
    //       <button type="button" onClick={() => setClient({})}>
    //         <svg
    //           className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
    //           focusable="false"
    //           viewBox="0 0 24 24"
    //           ariaHidden="true">
    //           <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    //         </svg>
    //       </button>
    //     </div>
    //   </div>
    // </div>

    //       <SearchClientModal
    //         open={isModalOpen}
    //         title="Nome do Cliente"
    //         setOpen={() => {
    //           setIsModalOpen((oldState) => !oldState);
    //         }}
    //         fieldName="Pesquise pelo nome do cliente"
    //         next={(client) => {
    //           setClient(client);
    //           setIsModalOpen(false);
    //         }}
    //       />

    //       <div>
    //         <button className="button" type="submit">
    //           Filtrar
    //         </button>
    //       </div>
    //     </form>
  );
};

export default DatePeriodFilter;
